/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Btn_ResendInputs */

const en_btn_resend = /** @type {(inputs: Btn_ResendInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Resend`)
};

/**
* | output |
* | --- |
* | "Resend" |
*
* @param {Btn_ResendInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const btn_resend = /** @type {((inputs?: Btn_ResendInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Btn_ResendInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_btn_resend(inputs)
});